module.exports = __webpack_public_path__ + "img/teamIcon.2fb5bc87.svg";